import React, { useState, useEffect } from "react";
import Global from '../../APIConfig';
import  axios from "axios";
import AuthUser from "../../AuthUser";
import { useNavigate } from "react-router-dom";
import { Bar,Line } from 'react-chartjs-2'
import { Chart, registerables } from 'chart.js'
import ListLoader from "../Loaders/ListLoader";
Chart.register(...registerables)

  function BagsChart(){
    let navigate = useNavigate();
    const{headers1,logout}=AuthUser();
    const [Label, setLabel] = useState('');
    const [Values, setValues] = useState('');
    const [Loading, setLoading] = useState(true);
    const [todayBags, setTodayBags]=useState('');
    const [bagsLast30Days, setBagsLast30Days]=useState('');
    useEffect(()=>{
        Get30DaysBags();
    },[]);
    
    const Get30DaysBags=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Get30DaysBagsreport',
            headers:headers1,
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data;
                setLabel(data.label);
                setValues(data.value);
                setTodayBags(data.todayBags);
                setBagsLast30Days(data.bagsLast30Days);
            }
            else
            {
                setLabel();
                setValues();
                setTodayBags();
                setBagsLast30Days();
            }
            setLoading(false);
          })
          .catch(function (error) {
            if(error.response.status==401){
                logout();
                navigate('/');
                window.location.reload();
            }
            setLoading(false);
            // console.log(error);
          });
    }

    const state = {
        labels: Label,
        datasets: [
          {
            label: 'Bags',
            backgroundColor: '#2155a9',
            fill: false,
            lineTension: 0.5,
            borderColor: '#2155a9',
            borderWidth: 2,
            data: Values,
          },
        ],
      }
    return (
        <div>
            {Loading==true ? <ListLoader/> :
            <>
            <div className="shipment_card_st_bx">
            <div className="row">
                <div className="col-12 col-md">
                    <h5>Bags Information</h5>
                    <h1>{todayBags} <small>Today</small></h1>
                    <h6>{bagsLast30Days} booked in last 30 days</h6>
                </div>
                <div className="col-12 col-md-4 text-end">
                    <a href="">Bags Report</a>
                </div>
            </div>
        </div>
          <Line
            data={state}
            options={{
              title: {
                display: true,
                text: 'Bags',
                fontSize: 20,
              },
              legend: {
                display: true,
                position: 'right',
              },
            }}
          />
          </>
          }
        </div>
      )
}

export default BagsChart
  
